// EnvBadge — prod / staging / dev pill.
//
// Per shell-strings.md: labels are intentionally NOT localized
// (env names are universal). Variants:
//   prod    = transparent bg + muted text + faint border (un-alarming)
//   staging = warn amber bg + white text
//   dev     = sky blue bg + white text
//
// Sourced from VITE_ENV_LABEL (config/env.ts). Single component used in
// both the sidebar footer and (potentially) the topbar.

import styles from './EnvBadge.module.css';

export type EnvLabel = 'prod' | 'staging' | 'dev';

export interface EnvBadgeProps {
  env: EnvLabel;
  className?: string;
}

const LABELS: Record<EnvLabel, string> = {
  prod: 'PROD',
  staging: 'STAGING',
  dev: 'DEV',
};

export function EnvBadge({ env, className }: EnvBadgeProps) {
  return (
    <span
      className={[styles.badge, styles[`env_${env}`], className].filter(Boolean).join(' ')}
      aria-label={`Environment: ${LABELS[env]}`}
    >
      {LABELS[env]}
    </span>
  );
}
